export default "__VITE_ASSET__6AbZVCUh__"